import { Tabs } from "client/CommonComponents"
import PurchaseOrderBreadcrumb from "../PurchaseOrder/PurchaseOrderBreadcrumb"
import OrderDetailView from "../OrderDetailView";
import PurchaseOrder from "../PurchaseOrder";
import OrderDetailViewBreadcrumb from "../OrderDetailView/OrderDetailViewBreadcrumb";
import PurchaseBulkOrder from "../PurchaseBulkOrder";
import ApprovalHistory from '../ApprovalHistory';

const PurchaseOrderMainContainer = (props:any) => {
  const { isBulkOrder, tab } = props 
  const tabItems = [
    {
      itemKey: "requisition",
      headerText: "Order Details",
      content: <OrderDetailView 
      isBulkOrder={isBulkOrder} 
      setSelectedKey={props.setSelectedKey} 
      tab={tab}
      tabSwitchClicked={props.tabSwitchClicked}
      setTabSwitchClicked={props.setTabSwitchClicked}
      />,
    },
    {
      itemKey: "approvalHistory",
      headerText: "Approval History",
      content:   <ApprovalHistory 
      setSelectedKey={props.setSelectedKey} 
      tab={tab}
      tabSwitchClicked={props.tabSwitchClicked}
      setTabSwitchClicked={props.setTabSwitchClicked}
      />
    },
    {
      itemKey: "fleet-processing",
      headerText: "Fleet Processing",
      content: isBulkOrder ?
        <PurchaseBulkOrder
          selectedKey={props?.selectedKey}
          setSelectedKey={props.setSelectedKey}
          tabSwitchClicked={props.tabSwitchClicked}
          setTabSwitchClicked={props.setTabSwitchClicked}
          setShowFleetBreadcrumb={props.setShowFleetBreadcrumb}
          tab={tab}
        /> :
        <PurchaseOrder
          selectedKey={props?.selectedKey}
          setSelectedKey={props.setSelectedKey}
          tabSwitchClicked={props.tabSwitchClicked}
          setTabSwitchClicked={props.setTabSwitchClicked}
          setShowFleetBreadcrumb={props.setShowFleetBreadcrumb}
          isBulkOrder={isBulkOrder}
          tab={tab}
        />
    },
  ];
        
    return(<div className="myOrderDetial" ref={props.wrapperRef} >
        { !props?.showFleetBreadcrumb ? <OrderDetailViewBreadcrumb/> : <PurchaseOrderBreadcrumb isBulkOrder={isBulkOrder} />}
        <Tabs
        className={`custom-tab `}
        tabItems={tabItems}
        selectedKey={props?.selectedKey}
        handleLinkClick={props?.handleLinkClick}
        data-attribute="PurchaseOrderMainContainer_Default_Tabs" />    
    </div>)
}

export default PurchaseOrderMainContainer